import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../services/supabase';
import styles from './AnnouncementBanner.module.css';

const AnnouncementBanner = () => {
  const location = useLocation();
  const [announcements, setAnnouncements] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [rotationSpeed, setRotationSpeed] = useState(5);
  const [bgColor, setBgColor] = useState('#1F5B3A');
  const [textColor, setTextColor] = useState('#FFFFFF');
  const [fade, setFade] = useState(true);
  const intervalRef = useRef(null);

  const isAdminRoute = location.pathname.startsWith('/admin');

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  useEffect(() => {
    if (!isActive || announcements.length === 0) return;

    if (intervalRef.current) clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % announcements.length);
        setFade(true);
      }, 300); // fade out duration
    }, rotationSpeed * 1000);

    return () => clearInterval(intervalRef.current);
  }, [isActive, announcements, rotationSpeed]);

  const fetchAnnouncements = async () => {
    const { data, error } = await supabase
      .from('announcements')
      .select('text, is_active, speed, bg_color, text_color, icon')
      .eq('is_active', true)
      .order('created_at', { ascending: true });

    if (data && data.length > 0) {
      setAnnouncements(data);
      setIsActive(true);
      setRotationSpeed(data[0]?.speed || 5);
      setBgColor(data[0]?.bg_color || '#1F5B3A');
      setTextColor(data[0]?.text_color || '#FFFFFF');
    } else {
      setIsActive(false);
    }
  };

  if (!isActive || announcements.length === 0 || isAdminRoute) return null;

  const current = announcements[currentIndex] || announcements[0];
  const marqueeSpeed = 20;

  return (
    <div className={styles.announcementBanner} style={{ background: bgColor, color: textColor }}>
      <div className={styles.marqueeWrapper}>
        <div className={`${styles.marquee} ${fade ? styles.fadeIn : styles.fadeOut}`} style={{ animationDuration: `${marqueeSpeed}s` }}>
          <span className={styles.marqueeContent}>{current.icon || '📢'} {current.text}</span>
          <span className={styles.marqueeContent}>{current.icon || '📢'} {current.text}</span>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBanner;